declare var process: any;

export interface Messages {
    [msgId: string]: string | Messages;
}

declare var jimdoData: {
    messages: Messages;
};

// Siteadmin iframe hack, except when run in test env (nodejs) where top !== window
if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require. Use 'diy.editor.util.l10n' instead");
}

function tr(msgId: string, htmlDecode = false) {
    if ('string' !== typeof msgId) {
        return undefined;
    }

    let msg: Messages|string = jimdoData.messages;
    let pieces = msgId.split(".");

    for (let piece of pieces) {
        if (undefined === msg) {
            break;
        }

        msg = (<Messages>msg)[piece];
    }

    if (typeof msg === 'string' && msg.length && htmlDecode) {
        msg = diy.editor.htmlDecode(<string>msg);
    }

    if (!msg) {
        // Use translation key when translation is unset
        msg = msgId;
    }

    return msg;
};

export function getString(msgId: string, htmlDecode = false) {
    return <string>tr(msgId, htmlDecode);
}

export function getMessages(key: string) {
    return <Messages>tr(key);
}

export default getString;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/l10n.ts
 **/